export const categories = [
  {
    id: 'jiaoyou',
    name: '男同交友',
    slug: 'jiaoyou',
    description: '找到志同道合的伙伴，开启属于你的精彩社交圈',
    icon: 'ri-heart-line',
    articleCount: 48,
  },
  {
    id: 'shenghuo',
    name: '生活资讯',
    slug: 'shenghuo',
    description: '最新最全的男同生活资讯，涵盖衣食住行各方面',
    icon: 'ri-lightbulb-line',
    articleCount: 36,
  },
  {
    id: 'jiankang',
    name: '健康指南',
    slug: 'jiankang',
    description: '专业的男同健康知识，关爱自己从了解开始',
    icon: 'ri-mental-health-line',
    articleCount: 29,
  },
  {
    id: 'huodong',
    name: '活动信息',
    slug: 'huodong',
    description: '全国男同活动汇总，线上线下精彩不停',
    icon: 'ri-calendar-event-line',
    articleCount: 22,
  },
  {
    id: 'shequn',
    name: '社群互动',
    slug: 'shequn',
    description: '分享故事，交流心得，在这里找到归属感',
    icon: 'ri-group-line',
    articleCount: 35,
  },
  {
    id: 'zixun',
    name: '资讯热点',
    slug: 'zixun',
    description: '关注男同群体相关新闻，把握最新动态',
    icon: 'ri-newspaper-line',
    articleCount: 41,
  },
];